module.exports = __webpack_public_path__ + "img/client_bailleurs.63b37376.png";